import React, { useState, useEffect } from 'react'
import Autosuggest from 'react-autosuggest';
import PropTypes from "prop-types"; 
import { translate } from 'utils/common';
// import useProductSearchDisable from 'components/common/productSearch/productSearchDisableHook';

export default function AutoSuggestWrapper(props) {
    const [autoSuggest, setautoSuggest] = useState({
        value: props.defaultValue || '',
        suggestions: [],
    });

    useEffect(() => {
        setautoSuggest((prevValue) => {
            return {
                value: props.defaultValue || '',
                suggestions: []
            }
        });
    }, [props.defaultValue])
    // const [toggle, setToggle] = useToggle(false);
    // const [disableEdit] = useProductSearchDisable(props);

    function onAutoSuggestInputChange(event, { newValue }) {
        ///Hack.sometimes  was coming as 'newvalue' coming as dropdown option
        if(newValue.indexOf(" ( ")!=-1){
            newValue = newValue.split(" ( ")[1].split(' )')[0];
        }
        updateValueForAutoSuggest(newValue);
    }

    function updateValueForAutoSuggest(newValue) {
        setautoSuggest((prevValue) => {
            return {
                ...prevValue,
                value: String(newValue)
            }
        });
    }
    function onKeyDown (event) {
        switch (event.keyCode) { 
          case 13: {
            event.preventDefault();
            props.onChange({ target: { name: props.name, value: event.target.value } });        
          } 
        }
      };

    const inputProps = {
        value: autoSuggest.value,
        onChange: onAutoSuggestInputChange,
        className: 'form-control width-100',
        placeholder: translate('search'),
        autoFocus: true,
        onKeyDown: onKeyDown,
    };

    async function onSuggestionsFetchRequested({ value }) {
        const MIN_COUNT = 3;
        if (!value || value.length < MIN_COUNT) {
            return;
        }
        let suggestions = await props.onSuggestionsFetchRequested(value);
        setautoSuggest((prevValue) => {
            return {
                ...prevValue,
                suggestions: suggestions
            }
        });
    }

    function onSuggestionsClearRequested() {
        setautoSuggest((prevValue) => {
            return {
                ...prevValue,
                suggestions: []
            }
        });
    }
    function getSuggestionValue(suggestion) {
        return generateDisplayName(suggestion);
    }
    function renderSuggestion(suggestion) {
        return <div>{generateDisplayName(suggestion)}</div>
    }
    function onSuggestionSelected(event, { suggestion }) {
        applyChanges(suggestion);
    }

    function generateDisplayName(model) {
        if (!model || !model.display_name) {
            return '-';
        } 
        if(props.displayNameFun){
            return props.displayNameFun(model)
        }  
        return model.display_name;
        // return model.display_name + (model.sap_product_id ? ` ( ${model.sap_product_id} )` : '');
    }

    function applyChanges(suggestion) {
        props.onChange({ target: { name: props.name, value: suggestion ? suggestion : {} } });
        // cancelChanges();
    }

    // function cancelChanges() {
    //     updateValueForAutoSuggest('');
    //     setToggle();
    // }

    // const renderInputComponent = inputProps => (
    //     <InputGroup>
    //         <Input {...inputProps} />
    //         <InputGroupAddon addonType="append">
    //             <Button color="secondary" onClick={() => cancelChanges()}>{translate('cancel')}</Button>
    //         </InputGroupAddon>
    //     </InputGroup>
    // );

    return (
        <React.Fragment>
            {/* {!toggle && <InputGroup>
                <Input type="text" disabled={true} value={generateDisplayName(props.value)} />
                <InputGroupAddon addonType="append">
                    <Button disabled={props.disabled || disableEdit} color="secondary" onClick={() => setToggle()}>{translate('edit')}</Button>
                </InputGroupAddon>
            </InputGroup>}
            {toggle && */}
                <React.Fragment>
                    <div className='col-lg p-0'>
                        <Autosuggest
                            suggestions={autoSuggest.suggestions}
                            onSuggestionsFetchRequested={onSuggestionsFetchRequested}
                            onSuggestionsClearRequested={onSuggestionsClearRequested}
                            getSuggestionValue={getSuggestionValue}
                            renderSuggestion={renderSuggestion}
                            onSuggestionSelected={onSuggestionSelected}
                            inputProps={inputProps}
                            // renderInputComponent={renderInputComponent}
                            >
                        </Autosuggest>
                    </div>
                </React.Fragment>
             {/* } */}
        </React.Fragment>
    )
}

AutoSuggestWrapper.defaultProps = { 
}

AutoSuggestWrapper.propTypes = {
    displayNameFun: PropTypes.func
}
